<template>
  <b-card title="جزییات:">
    
      <b-row>
        <b-col cols="12" sm="4" md="4">
          <b-form-group label="کد ملی:">
            <div class="form-control disabledbutton">
              {{ loadedDepositDetails.national_code }}
            </div>
          </b-form-group>
        </b-col>

        <b-col cols="12" sm="4" md="4">
          <b-form-group class="" label="بانک عامل(واریز کننده):">
            <div class="form-control disabledbutton">
              {{ loadedDepositDetails.from_bank }}
            </div>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="12" md="4">
          <b-form-group label="نام واریز کننده:">
            <div class="form-control disabledbutton">
              {{ loadedDepositDetails.owner_name }}
            </div>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="4" md="4">
          <b-form-group label="شبای واریز کننده:">
            <div class="form-control disabledbutton">
              {{ loadedDepositDetails.sheba_number }}
            </div>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="4" md="4">
          <b-form-group label="کد رهگیری تراکنش:">
            <b-form-input
            :disabled="loadedDepositDetails.tracking_number != null ? true : false"
              v-model="$v.payment.tracking_number.$model"
              :state="validateState('tracking_number')"
            ></b-form-input>
            <b-form-invalid-feedback
                  v-if="!$v.payment.tracking_number.required"
                  id="input-1-live-feedback"
                  >کد رهگیری را وارد کنید</b-form-invalid-feedback
                >
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="4" md="4">
          <b-form-group label="بانک مقصد:">
            <b-form-select
            :disabled="loadedDepositDetails.bank_account_id != null ? true : false"
              v-model="$v.payment.id.$model"
              :state="validateState('id')"
              :options="loadedBankList"
            ></b-form-select>
            <b-form-invalid-feedback
                  v-if="!$v.payment.id.required"
                  id="input-1-live-feedback"
                  >بانک مقصد را انتخاب کنید</b-form-invalid-feedback
                >
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="12" md="12">
          <b-form-group label="توضیحات تراکنش:">
            <div class="form-control disabledbutton">
              {{ loadedDepositDetails.desc }}
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" sm="2" md="2">
          <b-button
            v-if="loadedDepositDetails.tracking_number != null ? false : true"
            block
            @click="sendRequest"
            variant="success"
            :class="isBusy ? 'spinner spinner-light spinner-right' : ''"
            :disabled="showBtn"
            >پرداخت</b-button
          >
          <b-button
            v-else
            block
            @click="$router.push('/deposit-list')"
            variant="danger"
            >بازگشت</b-button
          >
        </b-col>
      </b-row>
  </b-card>
</template>
  
  <script>
/**
 * Import the DEPOSIT_WITH_ID and DEPOSIT_DETAILS_ID action types
 * from the DepositWithId store module
 */
import {
  DEPOSIT_WITH_ID,
  DEPOSIT_DETAILS_ID,
} from "@/core/services/store/DepositWithId.module";

/**
 * @module SET_BREADCRUMB
 * Action to set breadcrumb for the page
 */
 import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
/**
 * @module GET_BANK_LIST
 * Action to get the list of banks from the API
 */
 import { GET_BANK_LIST } from "@/core/services/store/getBankList.module";

/**
 * @module validationMixin
 * Mixin to add validation functionality to a Vue component
 */
import { validationMixin } from "vuelidate";

/**
 * @module required
 * Validator to check if a field is required
 */
import { required } from "vuelidate/lib/validators";

/**
 * DepositDetails component
 *
 * This component is responsible for displaying and managing the deposit details data.
 * It uses the DEPOSIT_WITH_ID and DEPOSIT_DETAILS_ID actions to fetch data from the store
 * and the loadedDepositDetails getter to retrieve the data from the store.
 *
 * @exports DepositDetails
 */
export default {
  name: "depositDetails",
   /**
   * @property {Array} mixins - Mixins to be added to the component
   * @property {Object} validationMixin - Mixin to add validation functionality to the component
   */
  mixins: [validationMixin],
  /**
   * Data object for the component
   *
   * @returns {Object} - The data object
   */
  data() {
    return {
      id: this.$route.params.id,
      isBusy: false,
      showBtn: false,
      payment: {
        tracking_number: null,
        id: null,
      },
    };
  },
   /**
   * @property {Object} validations - Object containing the validation rules for the component
   * @property {Object} payment - Object containing the validation rules for the payment data
   * @property {Object} payment.tracking_number - Object containing the validation rules for the tracking number field
   * @property {Object} payment.id - Object containing the validation rules for the id field
   * @property {Function} required - Validator to check if a field is required
   * */
  validations: {
    payment: {
      tracking_number: {
        required,
      },
      id: {
        required,
      },
    },
  },
  /**
   * Lifecycle hook called when the component is mounted
   */
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "جزییات و پرداخت" }]);
    this.getDetails();
    this.getBankList();
    
  },
  /**
   * Computed properties for the component
   */
  computed: {
    /**
     * Get the loaded deposit details from the store
     * @returns {*}
     */
    loadedDepositDetails() {
      return this.$store.getters.loadedDepositDetails;
    },
     /**
   * @property {Object} loadedBankList - computed property that returns the loaded bank list from the store
   */
    loadedBankList() {
      return this.$store.getters.loadedBankList;
    },
  },
  /**
   * Methods for the component
   */
  methods: {
    /**
     * Method to fetch deposit details by id
     */
    getDetails() {
      this.$store.dispatch(DEPOSIT_DETAILS_ID, `payid/select/${this.id}`).then((data)=>{
        if (data.success && this.loadedDepositDetails.bank_account_id!=null && this.loadedDepositDetails.tracking_number!=null) {
          this.$v.payment.id.$model=this.loadedDepositDetails.bank_account_id;
    this.$v.payment.tracking_number.$model=this.loadedDepositDetails.tracking_number;
        }
      });
    },
    /**
     * Method to pay refund
     */
    sendRequest() {
      this.$v.$touch();
      if (this.$v.payment.$anyError) {
        return;
      }
      this.isBusy = true;
      
      let api = `payid/confirm/${this.id}`;
      // let obj = {};
      // obj = Object.assign(obj, { payment: this.payment, api: api });
      // const{payment,api}=obj;
      const tracking_number=this.$v.payment.tracking_number.$model;
      const id=this.$v.payment.id.$model;
      const payload = {tracking_number,id,api}
      this.$store
        .dispatch(DEPOSIT_WITH_ID,payload)
        .then((data) => {
          if (data.success == true) {
            this.isBusy = false;
            this.getDetails();
            this.$makeToast(
              "success",
              "پرداخت موفق",
              "پرداخت با موفقیت انجام شد.",
              5000
            );
          } else {
            this.$makeToast("danger", "خطای ", "پرداخت با موفقیت انجام نشد٬لطفا مجددا تلاش نمایید.", 5000);
          }
        }).catch((error)=>{
          this.$makeToast("danger", "خطا", "خطای سمت سرور رخ داده است.", 5000);
        }).finally(()=>{
          this.isBusy = false});
    },
    /**
   * @function getBankList - Dispatch the GET_BANK_LIST action to the store to get the bank list
   * @see {@link https://vuex.vuejs.org/guide/actions.html}
   */
    getBankList() {
      this.$store.dispatch(GET_BANK_LIST);
    },
     /**
     * @function validateState - Validate the state of the input field
     * @param {string} name - The name of the input field
     * @returns {boolean | null} - Return true if the input is dirty and valid, false if the input is dirty and invalid, null if the input is not dirty
     */
    validateState(name) {
      const { $dirty, $error } = this.$v.payment[name];
      return $dirty ? !$error : null;
    },
  },
};
</script>

  <style>
.disabledbutton {
  pointer-events: none;
  opacity: 0.7;
}
.form-control.is-invalid, .was-validated .form-control:invalid {
  padding-right: calc(1.5em + 1.3rem);
}
.form-control.is-valid, .was-validated .form-control:valid {
  padding-right: calc(1.5em + 1.3rem);
}
.custom-select.is-valid, .was-validated .custom-select:valid{
  padding-right: calc(1.5em + 1.3rem);
}
.custom-select.is-valid, .was-validated .custom-select:valid {
    padding-right: calc(1.75em + 1.975rem);
}
</style>
  